// This file is auto-generated by @skynet/data-helpers/scripts/generate-rtk-exports.mjs
// Do not edit manually.

import { hookExports } from './trading-bots-api';

export const useListTradingBots: typeof hookExports.useListTradingBots =
  hookExports.useListTradingBots;
export const useLazyListTradingBots: typeof hookExports.useLazyListTradingBots =
  hookExports.useLazyListTradingBots;
